import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

function AnalyticsGAFAMPieChart({ companyColors, empty, data }) {
  return empty ? (
    <PieChart width={160} height={160}>
      <Pie
        data={[{ value: 1 }]}
        dataKey="value"
        innerRadius={45}
        outerRadius={70}
        paddingAngle={2}
        startAngle={89}
        endAngle={-271}
        isAnimationActive={false}
      >
        <Cell fill={companyColors.others} stroke='var(--bs-body-bg)' />
      </Pie>
    </PieChart>
  ) : (
    <PieChart width={160} height={160}>
      <Pie
        data={data}
        nameKey="company"
        dataKey="queries"
        innerRadius={45}
        outerRadius={70}
        paddingAngle={2}
        startAngle={89}
        endAngle={-271}
        isAnimationActive={false}
      >
        {data.map((entry, index) => (
          <Cell key={index} fill={companyColors[entry.company]} stroke='var(--bs-body-bg)' />
        ))}
      </Pie>
    </PieChart>
  );
}

export default AnalyticsGAFAMPieChart;
